import React, { useEffect, useState } from "react";
import Home from "./Home";
import Auth from "./Auth";
import AdminAuth from "./AdminAuth";
import Patron from "./Patron";
import moment from "moment";
import { BrowserRouter as Router, Route } from "react-router-dom";

export default function App() {
  const [state, setState] = useState();
  useEffect(() => {
    const dt = moment(new Date()).format("YYYY-MM-DD");
    if (dt > "2024-08-07") {
      window.location =
        "https://cmul.primo.exlibrisgroup.com/discovery/account?vid=66CMU_INST:cmul&section=overview&lang=en";
    } else if (dt < "2024-08-04") {
      let url = window.location.href;
      if (
        url === "http://apps2.lib.cmu.ac.th/renew" ||
        url === "http://apps2.lib.cmu.ac.th/renew/" ||
        url === "http://apps2.lib.cmu.ac.th/renew/#!"
      )
        window.location = "https://apps2.library.cmu.ac.th/renew";
      else setState(1);
    } else setState(2);
  }, []);

  return (
    <div>
      {state && (
        <>
          {state === 1 ? (
            <Router>
              <Route
                path={`${process.env.PUBLIC_URL}/`}
                exact
                component={() => <Home />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/auth`}
                exact
                component={() => <Auth />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/patron`}
                exact
                component={() => <Patron />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/login`}
                exact
                component={() => <AdminAuth />}
              />
            </Router>
          ) : (
            <div style={{ textAlign: "center", fontWeight: "500" }}>
              <br />
              <img
                src={process.env.PUBLIC_URL + "/img/site-under-maintenance.jpg"}
                style={{ maxWidth: "50vw" }}
                alt=""
              />
              <br />
              <br />
              ขออภัย สำนักหอสมุดอยู่ในระหว่างการปรับเปลี่ยนระบบใหม่
              <br />
              ท่านสามารถใช้งานได้อีกครั้งในวันที่ 8 สิงหาคม 2567
            </div>
          )}
        </>
      )}
    </div>
  );
}
